import { createApi } from '@reduxjs/toolkit/query/react'
import { MARK_ALL_NOTIFICATIONS_READ, MARK_SINGLE_NOTIFICATION_READ, NOTIFICATIONS_FILTER_TYPES, NOTIFICATIONS_LIST, UNREAD_NOTIFCATIONS_COUNT } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const notificationsApi = createApi({
    reducerPath: 'notificationsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/notification",
    }),
    tagTypes: ["NotificationsList", "UnreadNotificationsCount"],
    endpoints: (builder) => ({

        // classroom consultation list
        getNotifications: builder.query({
            query: ({ category = "", type = "", isRead = "", isCompleted = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: NOTIFICATIONS_LIST,
                    data: { category, type: type?.value || "", isRead, isCompleted, page, limit, sort }
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["NotificationsList"]
        }),

        // add classroom consultation
        markSingleNotificationRead: builder.mutation({
            query: ({ id }) => ({
                method: "PATCH",
                url: `/${id}${MARK_SINGLE_NOTIFICATION_READ}`,
            }),
            invalidatesTags: ["NotificationsList", "UnreadNotificationsCount"]
        }),

        markAllNotificationRead: builder.mutation({
            query: () => ({
                method: "PATCH",
                url: MARK_ALL_NOTIFICATIONS_READ,
            }),
            invalidatesTags: ["NotificationsList", "UnreadNotificationsCount"]
        }),

        getNotificationsFilterTypes: builder.query({
            query: () => {
                return ({
                    method: "GET",
                    url: NOTIFICATIONS_FILTER_TYPES,
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
        }),

         getUnreadNotificationsCount: builder.query({
            query: () => {
                return ({
                    method: "GET",
                    url: UNREAD_NOTIFCATIONS_COUNT,
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["UnreadNotificationsCount"],
        }),

    }),
})

export const {
    useGetNotificationsQuery,
    useMarkSingleNotificationReadMutation,
    useMarkAllNotificationReadMutation,
    useGetNotificationsFilterTypesQuery,
    useGetUnreadNotificationsCountQuery
} = notificationsApi;
